import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/notification-floating-item/notification-floating-item.js';
      import {ObcFloatingItemType, ObcFloatingItemDirection, ObcFloatingItemLineType} from '@oicl/openbridge-webcomponents/dist/components/floating-item/floating-item.js';

      export interface Props {
     type?: ObcFloatingItemType;
     direction?: ObcFloatingItemDirection;
     hasTimestamp?: boolean;
     hasDay?: boolean;
     action?: boolean;
     action2?: boolean;
     lineType?: ObcFloatingItemLineType
   }

      
  
      export type {ObcFloatingItemType, ObcFloatingItemDirection, ObcFloatingItemLineType} from '@oicl/openbridge-webcomponents/dist/components/floating-item/floating-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcNotificationFloatingItem',
  props: {
    type: {},
    direction: {},
    hasTimestamp: { type: Boolean },
    hasDay: { type: Boolean },
    action: { type: Boolean },
    action2: { type: Boolean },
    lineType: {}
  },
  emits: ["action-click", "action2-click", "dismiss-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onActionClick: (event: CustomEvent<void>) => emit('action-click', event as CustomEvent<void>),
onAction2Click: (event: CustomEvent<void>) => emit('action2-click', event as CustomEvent<void>),
onDismissClick: (event: CustomEvent<void>) => emit('dismiss-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-notification-floating-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})